import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Button, Table, Alert } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";

const ViewReceipt = () => {
  const [accounts, setAccounts] = useState([]);
  const [voucherHeads, setVoucherHeads] = useState([]);
  const [vfcs, setVfcs] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [selectedVfc, setSelectedVfc] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedVoucherHead, setSelectedVoucherHead] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [validationError, setValidationError] = useState("");
  const [noTransactionsMessage, setNoTransactionsMessage] = useState("");
  const { access } = useContext(AuthContext);
  const [emptyDataMessage, setEmptyDataMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const Config = Authorization();
    axios.get(`${Api}/api/accounts`, Config).then((response) => {
      setAccounts(response.data.data);
    });
    axios.get(`${Api}/api/voucher-types`, Config).then((response) => {
      setVoucherHeads(response.data.voucherTypes);
    });
    axios.get(`${Api}/api/vfcs`, Config).then((response) => {
      const data = response.data.vfcs;
      if (Array.isArray(data)) {
        setVfcs(data);
      } else {
        console.error("API did not return an array", data);
      }
    });
    setLoading(false);
  }, []);

  const handleFilter = async () => {
    if (
      !selectedVfc &&
      !selectedAccount &&
      !selectedVoucherHead &&
      !selectedDate
    ) {
      setValidationError("Please select at least one filter option.");
      setTransactions([]); // Clear previous transactions
      setEmptyDataMessage(""); // Clear any previous empty data message
      setLoading(false);
      return;
    }

    setValidationError("");
    setEmptyDataMessage("");

    try {
      const data = {
        vfc: selectedVfc || undefined,
        date: selectedDate ? new Date(selectedDate).toISOString() : undefined,
        account: selectedAccount || undefined,
        voucherType: selectedVoucherHead || undefined,
      };

      const response = await axios.post(
        `${Api}/api/transactions/filter/transactions`,
        data
      );

      const paymentTransactions = response.data.data.filter(
        (transaction) => transaction.type === "P"
      );
      console.log("receipt", paymentTransactions);

      if (paymentTransactions.length === 0) {
        setTransactions([]); // Clear previous transactions
        setNoTransactionsMessage("No payment transactions found."); // Set the message
      } else {
        setTransactions(paymentTransactions);
        setNoTransactionsMessage(""); // Clear the message if transactions are found
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setNoTransactionsMessage("Error fetching transactions.");
    }
  };

  return (
    <>
      <Preloader loading={loading} />
      <div className="container">
        <div className="page-header">
          <h3 className="page-title"> Filter Payments </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="!#" onClick={(event) => event.preventDefault()}>
                  VFC
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Filter Payment Transactions
              </li>
            </ol>
          </nav>
        </div>

        <>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <Form>
                  <Row>
                    <Col>
                      {/* VFC Dropdown */}
                      <Form.Group controlId="vfcSelect">
                        <Form.Label>Select VFC</Form.Label>
                        <Form.Control
                          as="select"
                          value={selectedVfc}
                          onChange={(e) => setSelectedVfc(e.target.value)}
                        >
                          <option value="">Select VFC</option>
                          {vfcs.map((vfc) => (
                            <option key={vfc._id} value={vfc._id}>
                              {vfc.vfcName}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      {/* Account Dropdown */}
                      <Form.Group controlId="accountSelect">
                        <Form.Label>Select Account</Form.Label>
                        <Form.Control
                          as="select"
                          value={selectedAccount}
                          onChange={(e) => setSelectedAccount(e.target.value)}
                        >
                          <option value="">Select Account</option>
                          {accounts.map((account) => (
                            <option key={account._id} value={account._id}>
                              {account.accountName}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      {/* Voucher Head Dropdown */}
                      <Form.Group controlId="voucherHeadSelect">
                        <Form.Label>Select Voucher Head</Form.Label>
                        <Form.Control
                          as="select"
                          value={selectedVoucherHead}
                          onChange={(e) =>
                            setSelectedVoucherHead(e.target.value)
                          }
                        >
                          <option value="">Select Voucher Head</option>
                          {voucherHeads.map((voucherHead) => (
                            <option
                              key={voucherHead._id}
                              value={voucherHead._id}
                            >
                              {voucherHead.voucherName}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      {/* Date Picker */}
                      <Form.Group controlId="dateSelect">
                        <Form.Label>Select Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={selectedDate}
                          onChange={(e) => setSelectedDate(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-icon-text mt-3"
                  onClick={handleFilter}
                >
                  <i className="mdi mdi-file-check btn-icon-prepend"></i>
                  Filter Payments
                </button>
              </div>
            </div>
          </div>

          {validationError && (
            <Alert variant="danger" className="mt-3">
              {validationError}
            </Alert>
          )}
          {emptyDataMessage && (
            <Alert variant="info" className="mt-3">
              {emptyDataMessage}
            </Alert>
          )}

          {noTransactionsMessage && <div>{noTransactionsMessage}</div>}
          <div className="card">
            <div className="card-body">
              <div className="row icons-list">
                <div className="Table_data">
                  <Table striped bordered hover className="mt-4">
                    <thead>
                      <tr>
                        <th>Voucher Type</th>
                        <th>Voucher Number</th>
                        <th>Description</th>
                        <th>Date</th>
                        <th>Party Details</th>
                        <th>Account</th>
                        <th>Amount</th>
                        <th>VFC</th>
                        <th>Cash/Bank</th>
                        <th>Docs</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((transaction) => (
                        <tr key={transaction._id}>
                          <td>
                            {transaction.voucherType &&
                            transaction.voucherType.voucherName
                              ? transaction.voucherType.voucherName
                              : "N/A"}
                          </td>
                          <td>{transaction.voucherNumber}</td>
                          <td>{transaction.description}</td>
                          <td>
                            {new Date(transaction.date).toLocaleDateString()}
                          </td>
                          <td>{transaction.partyDetails}</td>
                          <td>{transaction.accountId.accountName}</td>
                          <td>{transaction.amount}</td>
                          <td>{transaction.vfcId.vfcName}</td>
                          <td>{transaction.cashOrBank}</td>
                          <td>
                            <a
                              href={`${Api}${transaction.uploadDocument}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              ViewDocument
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default ViewReceipt;
